module.exports = __webpack_public_path__ + "static/img/icon_hzj.26812580.png";